// extracted by mini-css-extract-plugin
export default {"files":"yt1RIg7F","file-item":"shkjbEAT","fileItem":"shkjbEAT","file-name":"JViDVjrG","fileName":"JViDVjrG","close-icon":"jqfMTAOR","closeIcon":"jqfMTAOR"};